/**
 * CourseCategoryStatusService
 * Service for CourseCategoryStatus entity operations
 * Route: api/course-category-statuses
 */
import { BaseService } from '../base/BaseService';
/**
 * CourseCategoryStatusService
 * Handles course category status CRUD operations
 */
export class CourseCategoryStatusService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? CourseCategoryStatusService.DEFAULT_SERVICE_PATH,
            basePath: CourseCategoryStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all course category statuses
     * @returns Promise resolving to array of course category statuses
     */
    async getAll() {
        const response = await this.getAllRaw();
        return response.data ?? [];
    }
    /**
     * Get all course category statuses (raw response)
     * @returns Promise resolving to ResponseData with course category statuses
     */
    getAllRaw() {
        const url = this.buildUrl('');
        return this.http.get(url);
    }
    /**
     * Get course category status by ID
     * @param id - Status ID
     * @returns Promise resolving to course category status or null
     */
    async getById(id) {
        const response = await this.getByIdRaw(id);
        return response.data ?? null;
    }
    /**
     * Get course category status by ID (raw response)
     * @param id - Status ID
     * @returns Promise resolving to ResponseData with course category status
     */
    getByIdRaw(id) {
        const endpoint = this.getEndpoint('getById', `${id}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    /**
     * Create a new course category status
     * @param status - Status data
     * @returns Promise resolving to created course category status
     */
    async create(status) {
        const response = await this.createRaw(status);
        return response.data ?? null;
    }
    /**
     * Create a new course category status (raw response)
     * @param status - Status data
     * @returns Promise resolving to ResponseData with created course category status
     */
    createRaw(status) {
        const url = this.buildUrl('');
        return this.http.post(url, status);
    }
    /**
     * Update an existing course category status
     * @param id - Status ID
     * @param status - Updated status data
     * @returns Promise resolving to updated course category status
     */
    async update(id, status) {
        const response = await this.updateRaw(id, status);
        return response.data ?? null;
    }
    /**
     * Update an existing course category status (raw response)
     * @param id - Status ID
     * @param status - Updated status data
     * @returns Promise resolving to ResponseData with updated course category status
     */
    updateRaw(id, status) {
        const endpoint = this.getEndpoint('update', `${id}`);
        const url = this.buildUrl(endpoint);
        return this.http.put(url, status);
    }
    /**
     * Delete a course category status
     * @param id - Status ID
     * @returns Promise resolving to true if successful
     */
    async delete(id) {
        const response = await this.deleteRaw(id);
        return response.success;
    }
    /**
     * Delete a course category status (raw response)
     * @param id - Status ID
     * @returns Promise resolving to ResponseData
     */
    deleteRaw(id) {
        const endpoint = this.getEndpoint('delete', `${id}`);
        const url = this.buildUrl(endpoint);
        return this.http.delete(url);
    }
}
CourseCategoryStatusService.DEFAULT_SERVICE_PATH = 'resources';
CourseCategoryStatusService.BASE_PATH = 'api/course-category-statuses';
//# sourceMappingURL=CourseCategoryStatusService.js.map